<template>
  <AboutInfo />
</template>

<script>
import AboutInfo from "../components/about/AboutInfo.vue";

export default {
  name: "About",
  components: { AboutInfo },
};
</script>
